export default __webpack_public_path__ + "static/media/brand1-dark.9936db2f.svg";